import { render } from "./PetOwner.vue?vue&type=template&id=22237582&scoped=true"
import script from "./PetOwner.vue?vue&type=script&lang=js"
export * from "./PetOwner.vue?vue&type=script&lang=js"

import "./PetOwner.vue?vue&type=style&index=0&id=22237582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22237582"]])

export default __exports__